import { render, staticRenderFns } from "./sizhen-patients.vue?vue&type=template&id=47420811&"
import script from "./sizhen-patients.vue?vue&type=script&lang=ts&"
export * from "./sizhen-patients.vue?vue&type=script&lang=ts&"
import style0 from "./sizhen-patients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports